import { Box, TextField, Typography } from "@mui/material";
import React from "react";

function TextInput({
  value,
  onChange = () => {},
  onBlur = () => {},
  name,
  type = "text",
  label,
  error = false,
  fullWidth = true,
  required = false,
  margin = 1,
  marginY = 2,
  marginTop = 2,
  hide = false,
  helperText = "defaultErrorText",
  marginX,
  disabled,
  ...others
}) {
  return (
      <Box sx={{ m: margin, marginY:marginY, marginTop:marginTop }}>
        <Typography variant="subtitle1">
          {label}
        </Typography>
        <TextField
          disabled={disabled}
          fullWidth={fullWidth}
          required={required}
          type={type}
          name={name}
          value={value}
          onChange={(e) => onChange(e)}
          onBlur={(e) => onBlur(e)}
          size="small"
          error={error}
          helperText={error && helperText}
          sx={{backgroundColor: disabled ? "#eef1f5" : "white"}}
          {...others}
        />
      </Box>
  );
}

export default TextInput;
